// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { PanopticPanelsAPIResponse } from '../types/panoptic';

const { REACT_APP_PANOPTIC_API_URL } = process.env;

// Define a service using a base URL and expected endpoints
export const panopticApi = createApi({
  reducerPath: 'panopticApi',
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_PANOPTIC_API_URL,
  }),
  endpoints: (builder) => ({
    getPanels: builder.query<PanopticPanelsAPIResponse, void>({
      query: () => `/panels/`,
      transformResponse: (response: PanopticPanelsAPIResponse) => {
        return { ...response, panels: response.entities.map(formatPanel) };
      },
    }),
  }),
});

const formatPanel = (panelUrl: string) => {
  const pieces = panelUrl.split('/');
  const panelId = pieces[4];
  return { id: panelId, name: `Panel ${panelId}` };
};

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPanelsQuery } = panopticApi;
